import { action, makeObservable, observable, runInAction } from "mobx";
import { PaginatedAPIResponse } from "../../../models/NetworkResponse";
import LeadAPI from "../api/LeadAPI";
import { Leads, LeadSource } from "../../../models/Leads/leads";
import { LeadsFilters } from "../../../models/Leads/leadsFilter";

export class LeadsStore {
  leadAPI: LeadAPI;
  leads: Leads[] = [];
  sources: LeadSource[] = [];
  limit: number = 0;
  total_count: number = 0;
  total_pages: number = 0;
  selectedLeadDetails: Leads | null = null;
  isDetailsPopupOpen: boolean = false;

  constructor() {
    this.leadAPI = new LeadAPI();
    this.leads = [];
    this.limit = 0;
    this.total_count = 0;
    this.total_pages = 0;
    this.selectedLeadDetails = null;
    this.isDetailsPopupOpen = false;

    makeObservable(this, {
      leads: observable,
      sources: observable,
      limit: observable,
      total_count: observable,
      total_pages: observable,
      selectedLeadDetails: observable,
      isDetailsPopupOpen: observable,
      getLeads: action,
      getSources: action,
      setSelectedLeadDetails: action,
      clearSelectedLeadDetails: action,
      openDetailsPopup: action,
      closeDetailsPopup: action,
    });
  }

  getLeads = async (filters: LeadsFilters) => {
    try {
      const response = (await this.leadAPI.getLeads(
        filters,
      )) as PaginatedAPIResponse<Leads>;
      runInAction(() => {
        this.limit = response.limit;
        this.total_count = response.total_count;
        this.total_pages = response.total_pages;
        this.leads = response.list;
      });
    } catch (error: any) {
      throw error;
    }
  };

  getSources = async () => {
    try {
      const response = await this.leadAPI.getSources();
      runInAction(() => {
        this.sources = response.result ?? [];
      });
    } catch (error: any) {
      throw error;
    }
  };

  setSelectedLeadDetails = (lead: Leads) => {
    this.selectedLeadDetails = lead;
  };

  clearSelectedLeadDetails = () => {
    this.selectedLeadDetails = null;
  };

  openDetailsPopup = () => {
    this.isDetailsPopupOpen = true;
  };

  closeDetailsPopup = () => {
    this.isDetailsPopupOpen = false;
    this.selectedLeadDetails = null;
  };
}
